import { render, staticRenderFns } from "./RechnungsplitModal.vue?vue&type=template&id=027f35aa"
import script from "./RechnungsplitModal.vue?vue&type=script&lang=js"
export * from "./RechnungsplitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports